import { render, staticRenderFns } from "./MandalaGoalTemplateFormEntryItem.vue?vue&type=template&id=ab72aafc&"
import script from "./MandalaGoalTemplateFormEntryItem.vue?vue&type=script&lang=js&"
export * from "./MandalaGoalTemplateFormEntryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports